// src/i18n.js
import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
    en: {
        services: {
            title: 'Our Services',
            description: 'Discover how we help individuals and families achieve financial stability and growth through tailored solutions.',
            learnMore: 'Learn More',
            close: 'Close',
            details: {
                insurance: 'Our insurance planning service ensures that your assets are fully protected.',
                retirement: 'We help you plan for a financially secure retirement.',
                wealth: 'Our wealth management service offers a balanced approach to asset growth and risk management.',
            },
        },
    },
    fr: {
        services: {
            title: 'Nos Services',
            description: 'Découvrez comment nous aidons les individus et les familles à atteindre la stabilité et la croissance financières.',
            learnMore: 'En savoir plus',
            close: 'Fermer',
            details: {
                insurance: 'Notre service de planification d\'assurance garantit que vos actifs sont pleinement protégés.',
                retirement: 'Nous vous aidons à planifier une retraite financièrement sécurisée.',
                wealth: 'Notre service de gestion de patrimoine propose une approche équilibrée de la croissance des actifs et de la gestion des risques.',
            },
        },
    },
    // Add more languages here...
};

export default new VueI18n({
    locale: 'en',       // Default language
    fallbackLocale: 'en',
    messages,
});
